export const selectConnectionAction = (store)=>store.tvConnectionSlice.action
export const selectConnectionStatus = (store)=>store.tvConnectionSlice.isConnected
